import moment from 'moment';
import {
  useCreateCRFDataMutation,
  useDeleteAssociationEventMutation,
  useDeleteAssociationMutation,
  useGetCRFEventMutation,
  useLazyGetVisitLinkedCRFsQuery,
  useSelectCRFDataMutation,
  useSelectCRFDataByIDMutation,
  useUpdateCRFDataMutation
} from 'src/services/trailNotebookCRF';

export const useCRFForms = () => {
  const sendBookMarkValue = (crfFormMetaData: any, bookmarkKey: any, renderingData: any) => {
    const formData = crfFormMetaData.sections.flatMap((section: any) => section.rows.flatMap((row: any) => row.fields));
    let returnVal = '';
    formData.map((metaData: any) => {
      if (bookmarkKey == metaData?.key) {
        if (
          metaData?.cmp == 'checkbox' &&
          metaData?.data_dictionary_values &&
          metaData?.data_dictionary_values.length > 0
        ) {
          if (renderingData[bookmarkKey] != null) {
            const valUesKeys = Object.keys(renderingData[bookmarkKey]);
            const checkBoxValues: any = [];
            valUesKeys.map((item: any) => {
              for (let i = 0; i < metaData?.data_dictionary_values.length; i++) {
                if (item == metaData?.data_dictionary_values[i].code_list_value_code) {
                  checkBoxValues.push(metaData?.data_dictionary_values[i].code_list_value);
                  break;
                }
              }
            });
            returnVal = checkBoxValues.toString();
          }
        } else if (
          metaData?.cmp == 'select' &&
          metaData?.data_dictionary_values &&
          metaData?.data_dictionary_values.length > 0
        ) {
          if (metaData?.multiple && renderingData[bookmarkKey] != null) {
            const multipleValueData = renderingData[bookmarkKey].key;
            const ddmValues: any = [];
            multipleValueData.map((item: any) => {
              for (let i = 0; i < metaData?.data_dictionary_values.length; i++) {
                if (
                  item?.value == metaData?.data_dictionary_values[i].code_list_value_code ||
                  item?.code_list_value_code == metaData?.data_dictionary_values[i].code_list_value_code
                ) {
                  ddmValues.push(metaData?.data_dictionary_values[i].code_list_value);
                  break;
                }
              }
            });
            returnVal = ddmValues.toString();
          } else {
            if (renderingData[bookmarkKey] != null) {
              returnVal = renderingData[bookmarkKey].label;
            }
          }
        } else if (
          metaData?.cmp == 'radio' &&
          metaData?.data_dictionary_values &&
          metaData?.data_dictionary_values.length > 0
        ) {
          for (let i = 0; i < metaData?.data_dictionary_values.length; i++) {
            if (renderingData[bookmarkKey] == metaData?.data_dictionary_values[i].code_list_value_code) {
              returnVal = metaData?.data_dictionary_values[i].code_list_value;
              break;
            }
          }
        } else if (metaData?.cmp == 'date' && metaData?.type == 'date_time' && renderingData[bookmarkKey] != null) {
          returnVal = moment(renderingData[bookmarkKey]).format('MM/DD/YYYY h:mm A');
        } else if (metaData?.cmp == 'date' && metaData?.type == 'date' && renderingData[bookmarkKey] != null) {
          returnVal = moment(renderingData[bookmarkKey]).format('MM/DD/YYYY');
        } else {
          returnVal = renderingData[bookmarkKey];
        }
      }
    });
    return returnVal;
  };

  const getCheckboxValue = (fieldData: any, rawData: any) => {
    let returnVal: any = '';
    if (rawData != null) {
      if (Array.isArray(rawData)) {
        rawData = rawData.reduce((a, v) => ({ ...a, [v]: true }), {});
      }
      const valUesKeys = Object.keys(rawData);
      const checkBoxValues: any = [];
      valUesKeys.map((item: any) => {
        if (rawData[item]) {
          for (let i = 0; i < fieldData?.data_dictionary_values.length; i++) {
            if (item == fieldData?.data_dictionary_values[i].code_list_value_code) {
              checkBoxValues.push(fieldData?.data_dictionary_values[i].code_list_value);
              break;
            }
          }
        }
      });
      returnVal = checkBoxValues.toString();
    }
    return returnVal;
  };

  const getRadioButtonValue = (fieldData: any, rawData: any) => {
    let returnVal: any = '';
    if (rawData != null) {
      for (let i = 0; i < fieldData?.data_dictionary_values.length; i++) {
        if (rawData == fieldData?.data_dictionary_values[i].code_list_value_code) {
          returnVal = `${fieldData.title}-${fieldData?.data_dictionary_values[i].code_list_value}`;
          break;
        }
      }
    }
    return returnVal;
  };

  const getAddedKeyData = (findedEventData: any) => {
    const dataObj: any = JSON.parse(JSON.stringify(findedEventData));
    if (Object.keys(dataObj).length > 0) {
      Object.keys(dataObj).map((dataKey: any) => {
        if (dataObj[dataKey] == null) {
          delete dataObj[dataKey];
        }
        if (
          dataObj[dataKey] &&
          typeof dataObj[dataKey] == 'object' &&
          Object.keys(dataObj[dataKey]).includes('allow_partial_day')
        ) {
          if (Object.values(dataObj[dataKey]).filter((item: any) => item == null || item == '').length > 2) {
            delete dataObj[dataKey];
          }
        }
        if (Array.isArray(dataObj[dataKey])) {
          if (dataObj[dataKey].length > 0) {
            dataObj[dataKey] = { key: dataObj[dataKey] };
          }
          //else delete dataObj[dataKey];
        }
      });
      return dataObj;
    }
  };

  const [
    createCRFFormDataFunc,
    {
      data: createCRFFormData,
      isError: createCRFFormDataIsError,
      isSuccess: createCRFFormDataIsSuccess,
      isLoading: createCRFFormDataIsLoading,
      error: createCRFFormDataError
    }
  ] = useCreateCRFDataMutation();

  const [
    updateCRFFormDataFunc,
    {
      data: updateCRFFormData,
      isError: updateCRFFormDataIsError,
      isSuccess: updateCRFFormDataIsSuccess,
      isLoading: updateCRFFormDataIsLoading,
      error: updateCRFFormDataError
    }
  ] = useUpdateCRFDataMutation();

  const [
    getVisitLinkedCRFs,
    { data: getVisitLinkedCRFsData, isError: getVisitLinkedCRFsIsError, isLoading: getVisitLinkedCRFsIsLoading }
  ] = useLazyGetVisitLinkedCRFsQuery();

  const [deleteAssociation, { isError: deleteAssociationIsError, isSuccess: deleteAssociationIsSuccess }] =
    useDeleteAssociationMutation();

  const [
    deleteAssociationEvent,
    { isError: deleteAssociationEventIsError, isSuccess: deleteAssociationEventIsSuccess }
  ] = useDeleteAssociationEventMutation();

  const [
    getCRFEvent,
    {
      data: getCRFEventData,
      isError: getCRFEventIsError,
      isSuccess: getCRFEventIsSuccess,
      isLoading: getCRFEventIsLoading,
      error: getCRFEventError
    }
  ] = useGetCRFEventMutation();

  const [selectCRFData] = useSelectCRFDataMutation();
  const [selectCRFDataByID, {data:selectCRFDataByIDData,isLoading:selectCRFDataByIDIsLoading,isSuccess:selectCRFDataByIDIsSuccess,isError:selectCRFDataByIDIsError}] =   useSelectCRFDataByIDMutation()


  const shouldHide = (field: any, data: any) => {
    if (field['show_hide_value'] && field['show_hide']) {
      const tempOID = field['show_hide_variable_OID'];

      if (
        field['show_hide'] == 'show_if' &&
        'show_hide_value' in field &&
        data[tempOID] &&
        ((typeof data[tempOID] != 'object' && field['show_hide_value'] != data[tempOID]) ||
          (typeof data[tempOID] == 'object' &&
            data[tempOID]?.value &&
            field['show_hide_value'] != data[tempOID]?.value) ||
          (typeof data[tempOID] == 'object' &&
            Array.isArray(data[tempOID]) &&
            data[tempOID] &&
            !data[tempOID].includes(field['show_hide_value'])) ||
          (typeof data[tempOID] == 'object' &&
            data[tempOID] &&
            field['show_hide_value'].includes(Object.keys(data[tempOID])) &&
            data[tempOID]?.field &&
            data[tempOID]?.field['show_hide_value'] == false) ||
          (typeof data[tempOID] == 'object' &&
            data[tempOID] &&
            Object.keys(data[tempOID])
              .map(key => (data[tempOID][key] ? key : ''))
              ?.includes(field['show_hide_value'])))
      ) {
        return true;
      }
      if (
        field['show_hide'] == 'hide_if' &&
        ((typeof data[tempOID] != 'object' && field['show_hide_value'] == data[tempOID]) ||
          (typeof data[tempOID] == 'object' &&
            data[tempOID]?.value &&
            field['show_hide_value'] == data[tempOID]?.value) ||
          (typeof data[tempOID] == 'object' &&
            Array.isArray(data[tempOID]) &&
            data[tempOID].includes(field['show_hide_value'])) ||
          (typeof data[tempOID] == 'object' &&
            data[tempOID] &&
            field['show_hide_value'].includes(Object.keys(data[tempOID])) &&
            data[tempOID]?.field['show_hide_value'] == true))
      ) {
        return true;
      }
    }
    return false;
  };

  return {
    sendBookMarkValue,
    createCRFFormDataFunc,
    createCRFFormData,
    createCRFFormDataIsError,
    createCRFFormDataIsSuccess,
    createCRFFormDataIsLoading,
    createCRFFormDataError,
    updateCRFFormDataFunc,
    updateCRFFormData,
    updateCRFFormDataIsError,
    updateCRFFormDataIsSuccess,
    updateCRFFormDataIsLoading,
    updateCRFFormDataError,
    getVisitLinkedCRFs,
    getVisitLinkedCRFsData,
    getVisitLinkedCRFsIsLoading,
    deleteAssociation,
    deleteAssociationEvent,
    deleteAssociationIsSuccess,
    deleteAssociationEventIsSuccess,
    getVisitLinkedCRFsIsError,
    deleteAssociationIsError,
    deleteAssociationEventIsError,
    getCheckboxValue,
    getRadioButtonValue,
    getCRFEvent,
    getCRFEventData,
    getCRFEventIsError,
    getCRFEventIsSuccess,
    getCRFEventIsLoading,
    getCRFEventError,
    selectCRFData,
    selectCRFDataByID,
    selectCRFDataByIDData,
    selectCRFDataByIDIsLoading,
    selectCRFDataByIDIsSuccess,
    selectCRFDataByIDIsError,
    getAddedKeyData,
    shouldHide
  };
};
